import React from 'react'

import withStyles from '@material-ui/core/styles/withStyles'

import { PuzzleListCard } from 'containers'

const styles = theme => ({
})

class PuzzlePage extends React.Component {
  render() {
    const { userName, tg, wd, url } = this.props
    return (
      <PuzzleListCard disabledBoxShadow own {...{author: userName, tg, wd, url}}/>
    )
  }
}

export default withStyles(styles, { withTheme: true })(PuzzlePage)


// WEBPACK FOOTER //
// ./src/Pages/User/components/PuzzlePage.js